import { Box } from "@mui/material";
import { BasicSwitchText, CommonBoxWithNumber } from "@platformx/utilities";
import { useCustomStyle } from "../SEO/SEO.style";

const AuthorToggle = ({ titleSubTitles, state, handleChange }) => {
  const classes = useCustomStyle();
  const {
    sectionNumber,
    sectionTitle,
    sectionSubTitle,
    authorTitle,
    authorSubTitle,
    authorFieldName,
  } = titleSubTitles;

  return (
    <Box id='author' className={classes.mainStyleWrapper}>
      <CommonBoxWithNumber
        number={sectionNumber}
        title={sectionTitle}
        titleVarient='h5bold'
        subTitleVarient='p4regular'
        subTitle={sectionSubTitle}>
        <Box className='textFiled'>
          <BasicSwitchText
            state={Boolean(state?.[authorFieldName])}
            isDisable={false}
            handleChange={handleChange}
            title={authorTitle}
            subtitle={authorSubTitle}
            keyName={authorFieldName}
          />
        </Box>
      </CommonBoxWithNumber>
    </Box>
  );
};
export default AuthorToggle;
